import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
// Ular Tangga Pintar - Game Data

// Board: 10x10, numbered 1-100
// Snakes: go DOWN (head -> tail)
// Ladders: go UP (bottom -> top)

export const SNAKES = {
  98: 83,
  92: 71,
  83: 25,
  79: 49,
  73: 44,
  56: 42,
  28: 13,
};

export const LADDERS = {
  11: 30,
  16: 37,
  21: 40,
  35: 54,
  57: 64,
  61: 80,
};

// Convert square number (1-100) to row/col (for rendering)
export const squareToPosition = (num) => {
  const row = Math.floor((num - 1) / 10);
  const col = (num - 1) % 10;
  // Odd rows go right-to-left (snake pattern)
  const actualCol = row % 2 === 0 ? col : 9 - col;
  // Board renders top-to-bottom, but numbering starts bottom
  const actualRow = 9 - row;
  return { row: actualRow, col: actualCol };
};

// Get square number from visual row/col
export const positionToSquare = (row, col) => {
  const boardRow = 9 - row;
  const actualCol = boardRow % 2 === 0 ? col : 9 - col;
  return boardRow * 10 + actualCol + 1;
};

// Question squares (about 18 squares with questions - avoid snake/ladder squares)
export const QUESTION_SQUARES = [
  3, 7, 14, 18, 24, 31, 38, 43, 48, 52, 59, 65, 69, 75, 82, 88, 94, 97
];

// ============================================
// VISUAL QUESTIONS FOR 3-YEAR-OLDS
// Each question has:
//   q: text (for TTS/parent reading)
//   visual: what to show as the main visual prompt
//   options: array of option objects with { label, visual }
//   answer: index of correct answer
//   explain: explanation text
// ============================================

export const QUESTIONS = {
  huruf: [
    { q: "Tunjuk huruf A!", visual: { type: "letter", letter: "A", color: "#EF4444" },
      options: [{ label: "A", visual: { type: "letter", letter: "A", color: "#EF4444" } }, { label: "B", visual: { type: "letter", letter: "B", color: "#3B82F6" } }, { label: "C", visual: { type: "letter", letter: "C", color: "#22C55E" } }, { label: "D", visual: { type: "letter", letter: "D", color: "#A855F7" } }],
      answer: 0, explain: "A adalah huruf pertama!" },
    { q: "Tunjuk huruf B!", visual: { type: "letter", letter: "B", color: "#3B82F6" },
      options: [{ label: "D", visual: { type: "letter", letter: "D", color: "#F97316" } }, { label: "B", visual: { type: "letter", letter: "B", color: "#3B82F6" } }, { label: "C", visual: { type: "letter", letter: "C", color: "#22C55E" } }, { label: "A", visual: { type: "letter", letter: "A", color: "#EF4444" } }],
      answer: 1, explain: "B ada perutnya dua!" },
    { q: "Tunjuk huruf C!", visual: { type: "letter", letter: "C", color: "#22C55E" },
      options: [{ label: "G", visual: { type: "letter", letter: "G", color: "#A855F7" } }, { label: "D", visual: { type: "letter", letter: "D", color: "#F97316" } }, { label: "C", visual: { type: "letter", letter: "C", color: "#22C55E" } }, { label: "E", visual: { type: "letter", letter: "E", color: "#EAB308" } }],
      answer: 2, explain: "C bentuknya setengah lingkaran!" },
    { q: "Tunjuk huruf O!", visual: { type: "letter", letter: "O", color: "#F97316" },
      options: [{ label: "Q", visual: { type: "letter", letter: "Q", color: "#A855F7" } }, { label: "O", visual: { type: "letter", letter: "O", color: "#F97316" } }, { label: "D", visual: { type: "letter", letter: "D", color: "#3B82F6" } }, { label: "C", visual: { type: "letter", letter: "C", color: "#22C55E" } }],
      answer: 1, explain: "O bentuknya bulat!" },
    { q: "Tunjuk huruf S!", visual: { type: "letter", letter: "S", color: "#EC4899" },
      options: [{ label: "Z", visual: { type: "letter", letter: "Z", color: "#A855F7" } }, { label: "5", visual: { type: "letter", letter: "5", color: "#EAB308" } }, { label: "S", visual: { type: "letter", letter: "S", color: "#EC4899" } }, { label: "8", visual: { type: "letter", letter: "8", color: "#22C55E" } }],
      answer: 2, explain: "S bentuknya seperti ular!" },
    { q: "Tunjuk huruf M!", visual: { type: "letter", letter: "M", color: "#8B5CF6" },
      options: [{ label: "N", visual: { type: "letter", letter: "N", color: "#3B82F6" } }, { label: "W", visual: { type: "letter", letter: "W", color: "#22C55E" } }, { label: "M", visual: { type: "letter", letter: "M", color: "#8B5CF6" } }, { label: "H", visual: { type: "letter", letter: "H", color: "#EF4444" } }],
      answer: 2, explain: "M punya 2 gunung di atas!" },
    { q: "Tunjuk huruf I!", visual: { type: "letter", letter: "I", color: "#0EA5E9" },
      options: [{ label: "L", visual: { type: "letter", letter: "L", color: "#22C55E" } }, { label: "I", visual: { type: "letter", letter: "I", color: "#0EA5E9" } }, { label: "T", visual: { type: "letter", letter: "T", color: "#EF4444" } }, { label: "J", visual: { type: "letter", letter: "J", color: "#A855F7" } }],
      answer: 1, explain: "I bentuknya lurus ke atas!" },
    { q: "Tunjuk huruf U!", visual: { type: "letter", letter: "U", color: "#14B8A6" },
      options: [{ label: "V", visual: { type: "letter", letter: "V", color: "#EF4444" } }, { label: "W", visual: { type: "letter", letter: "W", color: "#3B82F6" } }, { label: "C", visual: { type: "letter", letter: "C", color: "#22C55E" } }, { label: "U", visual: { type: "letter", letter: "U", color: "#14B8A6" } }],
      answer: 3, explain: "U bentuknya seperti mangkok!" },
  ],
  angka: [
    { q: "Berapa bintangnya?", visual: { type: "stars", count: 1 },
      options: [{ label: "1", visual: { type: "dots", count: 1 } }, { label: "2", visual: { type: "dots", count: 2 } }, { label: "3", visual: { type: "dots", count: 3 } }, { label: "4", visual: { type: "dots", count: 4 } }],
      answer: 0, explain: "Ada 1 bintang!" },
    { q: "Berapa bintangnya?", visual: { type: "stars", count: 2 },
      options: [{ label: "1", visual: { type: "dots", count: 1 } }, { label: "3", visual: { type: "dots", count: 3 } }, { label: "2", visual: { type: "dots", count: 2 } }, { label: "4", visual: { type: "dots", count: 4 } }],
      answer: 2, explain: "Ada 2 bintang!" },
    { q: "Berapa bintangnya?", visual: { type: "stars", count: 3 },
      options: [{ label: "2", visual: { type: "dots", count: 2 } }, { label: "4", visual: { type: "dots", count: 4 } }, { label: "5", visual: { type: "dots", count: 5 } }, { label: "3", visual: { type: "dots", count: 3 } }],
      answer: 3, explain: "Ada 3 bintang!" },
    { q: "Berapa bintangnya?", visual: { type: "stars", count: 4 },
      options: [{ label: "3", visual: { type: "dots", count: 3 } }, { label: "5", visual: { type: "dots", count: 5 } }, { label: "4", visual: { type: "dots", count: 4 } }, { label: "2", visual: { type: "dots", count: 2 } }],
      answer: 2, explain: "Ada 4 bintang!" },
    { q: "Berapa bintangnya?", visual: { type: "stars", count: 5 },
      options: [{ label: "4", visual: { type: "dots", count: 4 } }, { label: "5", visual: { type: "dots", count: 5 } }, { label: "6", visual: { type: "dots", count: 6 } }, { label: "3", visual: { type: "dots", count: 3 } }],
      answer: 1, explain: "Ada 5 bintang!" },
    { q: "Berapa apelnya?", visual: { type: "apples", count: 2 },
      options: [{ label: "1", visual: { type: "dots", count: 1 } }, { label: "2", visual: { type: "dots", count: 2 } }, { label: "3", visual: { type: "dots", count: 3 } }, { label: "4", visual: { type: "dots", count: 4 } }],
      answer: 1, explain: "Ada 2 apel!" },
    { q: "Berapa apelnya?", visual: { type: "apples", count: 3 },
      options: [{ label: "2", visual: { type: "dots", count: 2 } }, { label: "4", visual: { type: "dots", count: 4 } }, { label: "3", visual: { type: "dots", count: 3 } }, { label: "1", visual: { type: "dots", count: 1 } }],
      answer: 2, explain: "Ada 3 apel!" },
    { q: "Mana yang lebih banyak?", visual: { type: "compare", left: 2, right: 4 },
      options: [{ label: "Kiri (2)", visual: { type: "dots", count: 2 } }, { label: "Kanan (4)", visual: { type: "dots", count: 4 } }, { label: "Sama", visual: { type: "dots", count: 0 } }, { label: "Kiri (2)", visual: { type: "dots", count: 2 } }],
      answer: 1, explain: "4 lebih banyak dari 2!" },
  ],
  warna: [
    { q: "Tunjuk warna MERAH!", visual: { type: "colorTarget", color: "#EF4444", emoji: "🍎", name: "Merah" },
      options: [{ label: "Biru", visual: { type: "colorCircle", color: "#3B82F6" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Hijau", visual: { type: "colorCircle", color: "#22C55E" } }, { label: "Kuning", visual: { type: "colorCircle", color: "#EAB308" } }],
      answer: 1, explain: "Merah seperti apel!" },
    { q: "Tunjuk warna BIRU!", visual: { type: "colorTarget", color: "#3B82F6", emoji: "🌊", name: "Biru" },
      options: [{ label: "Biru", visual: { type: "colorCircle", color: "#3B82F6" } }, { label: "Ungu", visual: { type: "colorCircle", color: "#A855F7" } }, { label: "Hijau", visual: { type: "colorCircle", color: "#22C55E" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }],
      answer: 0, explain: "Biru seperti langit!" },
    { q: "Tunjuk warna KUNING!", visual: { type: "colorTarget", color: "#EAB308", emoji: "🌟", name: "Kuning" },
      options: [{ label: "Orange", visual: { type: "colorCircle", color: "#F97316" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Kuning", visual: { type: "colorCircle", color: "#EAB308" } }, { label: "Hijau", visual: { type: "colorCircle", color: "#22C55E" } }],
      answer: 2, explain: "Kuning seperti bintang!" },
    { q: "Tunjuk warna HIJAU!", visual: { type: "colorTarget", color: "#22C55E", emoji: "🌿", name: "Hijau" },
      options: [{ label: "Biru", visual: { type: "colorCircle", color: "#3B82F6" } }, { label: "Kuning", visual: { type: "colorCircle", color: "#EAB308" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Hijau", visual: { type: "colorCircle", color: "#22C55E" } }],
      answer: 3, explain: "Hijau seperti daun!" },
    { q: "Tunjuk warna ORANGE!", visual: { type: "colorTarget", color: "#F97316", emoji: "🍊", name: "Orange" },
      options: [{ label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Orange", visual: { type: "colorCircle", color: "#F97316" } }, { label: "Kuning", visual: { type: "colorCircle", color: "#EAB308" } }, { label: "Pink", visual: { type: "colorCircle", color: "#EC4899" } }],
      answer: 1, explain: "Orange seperti jeruk!" },
    { q: "Tunjuk warna PINK!", visual: { type: "colorTarget", color: "#EC4899", emoji: "🌸", name: "Pink" },
      options: [{ label: "Pink", visual: { type: "colorCircle", color: "#EC4899" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Ungu", visual: { type: "colorCircle", color: "#A855F7" } }, { label: "Orange", visual: { type: "colorCircle", color: "#F97316" } }],
      answer: 0, explain: "Pink seperti bunga!" },
    { q: "Tunjuk warna UNGU!", visual: { type: "colorTarget", color: "#A855F7", emoji: "🍇", name: "Ungu" },
      options: [{ label: "Biru", visual: { type: "colorCircle", color: "#3B82F6" } }, { label: "Merah", visual: { type: "colorCircle", color: "#EF4444" } }, { label: "Ungu", visual: { type: "colorCircle", color: "#A855F7" } }, { label: "Pink", visual: { type: "colorCircle", color: "#EC4899" } }],
      answer: 2, explain: "Ungu seperti anggur!" },
  ],
  bentuk: [
    { q: "Tunjuk LINGKARAN!", visual: { type: "shapeTarget", shape: "circle", color: "#3B82F6" },
      options: [{ label: "Segitiga", visual: { type: "shape", shape: "triangle", color: "#EF4444" } }, { label: "Kotak", visual: { type: "shape", shape: "square", color: "#22C55E" } }, { label: "Lingkaran", visual: { type: "shape", shape: "circle", color: "#3B82F6" } }, { label: "Bintang", visual: { type: "shape", shape: "star", color: "#EAB308" } }],
      answer: 2, explain: "Lingkaran bulat!" },
    { q: "Tunjuk SEGITIGA!", visual: { type: "shapeTarget", shape: "triangle", color: "#EF4444" },
      options: [{ label: "Segitiga", visual: { type: "shape", shape: "triangle", color: "#EF4444" } }, { label: "Kotak", visual: { type: "shape", shape: "square", color: "#22C55E" } }, { label: "Lingkaran", visual: { type: "shape", shape: "circle", color: "#3B82F6" } }, { label: "Hati", visual: { type: "shape", shape: "heart", color: "#EC4899" } }],
      answer: 0, explain: "Segitiga punya 3 sudut!" },
    { q: "Tunjuk KOTAK!", visual: { type: "shapeTarget", shape: "square", color: "#22C55E" },
      options: [{ label: "Lingkaran", visual: { type: "shape", shape: "circle", color: "#3B82F6" } }, { label: "Segitiga", visual: { type: "shape", shape: "triangle", color: "#EF4444" } }, { label: "Bintang", visual: { type: "shape", shape: "star", color: "#EAB308" } }, { label: "Kotak", visual: { type: "shape", shape: "square", color: "#22C55E" } }],
      answer: 3, explain: "Kotak punya 4 sisi!" },
    { q: "Tunjuk BINTANG!", visual: { type: "shapeTarget", shape: "star", color: "#EAB308" },
      options: [{ label: "Hati", visual: { type: "shape", shape: "heart", color: "#EC4899" } }, { label: "Bintang", visual: { type: "shape", shape: "star", color: "#EAB308" } }, { label: "Kotak", visual: { type: "shape", shape: "square", color: "#22C55E" } }, { label: "Lingkaran", visual: { type: "shape", shape: "circle", color: "#3B82F6" } }],
      answer: 1, explain: "Bintang punya 5 ujung!" },
    { q: "Tunjuk HATI!", visual: { type: "shapeTarget", shape: "heart", color: "#EC4899" },
      options: [{ label: "Kotak", visual: { type: "shape", shape: "square", color: "#22C55E" } }, { label: "Lingkaran", visual: { type: "shape", shape: "circle", color: "#3B82F6" } }, { label: "Hati", visual: { type: "shape", shape: "heart", color: "#EC4899" } }, { label: "Segitiga", visual: { type: "shape", shape: "triangle", color: "#EF4444" } }],
      answer: 2, explain: "Hati bentuknya lucu!" },
  ],
  hewan: [
    { q: "Suara apa ini? MEONG!", visual: { type: "emoji", emoji: "🐱", size: "big" },
      options: [{ label: "Anjing", visual: { type: "emoji", emoji: "🐶" } }, { label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Burung", visual: { type: "emoji", emoji: "🐦" } }, { label: "Ikan", visual: { type: "emoji", emoji: "🐟" } }],
      answer: 1, explain: "Kucing bilang Meong!" },
    { q: "Suara apa ini? GUK GUK!", visual: { type: "emoji", emoji: "🐶", size: "big" },
      options: [{ label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Sapi", visual: { type: "emoji", emoji: "🐮" } }, { label: "Anjing", visual: { type: "emoji", emoji: "🐶" } }, { label: "Ayam", visual: { type: "emoji", emoji: "🐔" } }],
      answer: 2, explain: "Anjing bilang Guk Guk!" },
    { q: "Hewan apa yang bisa terbang?", visual: { type: "emoji", emoji: "🦅", size: "big" },
      options: [{ label: "Ikan", visual: { type: "emoji", emoji: "🐟" } }, { label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Burung", visual: { type: "emoji", emoji: "🦅" } }, { label: "Kelinci", visual: { type: "emoji", emoji: "🐰" } }],
      answer: 2, explain: "Burung bisa terbang!" },
    { q: "Hewan apa yang hidup di air?", visual: { type: "emoji", emoji: "🐟", size: "big" },
      options: [{ label: "Ikan", visual: { type: "emoji", emoji: "🐟" } }, { label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Singa", visual: { type: "emoji", emoji: "🦁" } }, { label: "Kelinci", visual: { type: "emoji", emoji: "🐰" } }],
      answer: 0, explain: "Ikan hidup di air!" },
    { q: "Hewan apa yang paling besar?", visual: { type: "emoji", emoji: "🐘", size: "big" },
      options: [{ label: "Semut", visual: { type: "emoji", emoji: "🐜" } }, { label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Gajah", visual: { type: "emoji", emoji: "🐘" } }, { label: "Kelinci", visual: { type: "emoji", emoji: "🐰" } }],
      answer: 2, explain: "Gajah adalah hewan yang sangat besar!" },
    { q: "Suara apa ini? KUKURUYUK!", visual: { type: "emoji", emoji: "🐔", size: "big" },
      options: [{ label: "Bebek", visual: { type: "emoji", emoji: "🦆" } }, { label: "Ayam", visual: { type: "emoji", emoji: "🐔" } }, { label: "Burung", visual: { type: "emoji", emoji: "🐦" } }, { label: "Angsa", visual: { type: "emoji", emoji: "🦢" } }],
      answer: 1, explain: "Ayam jantan bilang Kukuruyuk!" },
    { q: "Hewan apa yang suka makan wortel?", visual: { type: "emoji", emoji: "🐰", size: "big" },
      options: [{ label: "Kucing", visual: { type: "emoji", emoji: "🐱" } }, { label: "Anjing", visual: { type: "emoji", emoji: "🐶" } }, { label: "Kelinci", visual: { type: "emoji", emoji: "🐰" } }, { label: "Ikan", visual: { type: "emoji", emoji: "🐟" } }],
      answer: 2, explain: "Kelinci suka makan wortel!" },
    { q: "Suara apa ini? MOOO!", visual: { type: "emoji", emoji: "🐮", size: "big" },
      options: [{ label: "Sapi", visual: { type: "emoji", emoji: "🐮" } }, { label: "Kambing", visual: { type: "emoji", emoji: "🐐" } }, { label: "Kuda", visual: { type: "emoji", emoji: "🐴" } }, { label: "Domba", visual: { type: "emoji", emoji: "🐑" } }],
      answer: 0, explain: "Sapi bilang Mooo!" },
  ],
  buah: [
    { q: "Buah apa yang warnanya kuning dan melengkung?", visual: { type: "emoji", emoji: "🍌", size: "big" },
      options: [{ label: "Apel", visual: { type: "emoji", emoji: "🍎" } }, { label: "Pisang", visual: { type: "emoji", emoji: "🍌" } }, { label: "Jeruk", visual: { type: "emoji", emoji: "🍊" } }, { label: "Anggur", visual: { type: "emoji", emoji: "🍇" } }],
      answer: 1, explain: "Pisang kuning dan melengkung!" },
    { q: "Buah apa yang warnanya merah?", visual: { type: "emoji", emoji: "🍎", size: "big" },
      options: [{ label: "Apel", visual: { type: "emoji", emoji: "🍎" } }, { label: "Pisang", visual: { type: "emoji", emoji: "🍌" } }, { label: "Lemon", visual: { type: "emoji", emoji: "🍋" } }, { label: "Mangga", visual: { type: "emoji", emoji: "🥭" } }],
      answer: 0, explain: "Apel warnanya merah!" },
    { q: "Buah apa yang besar dan hijau, dalamnya merah?", visual: { type: "emoji", emoji: "🍉", size: "big" },
      options: [{ label: "Mangga", visual: { type: "emoji", emoji: "🥭" } }, { label: "Semangka", visual: { type: "emoji", emoji: "🍉" } }, { label: "Apel", visual: { type: "emoji", emoji: "🍎" } }, { label: "Jeruk", visual: { type: "emoji", emoji: "🍊" } }],
      answer: 1, explain: "Semangka besar hijau, dalamnya merah!" },
    { q: "Buah apa yang warnanya orange?", visual: { type: "emoji", emoji: "🍊", size: "big" },
      options: [{ label: "Anggur", visual: { type: "emoji", emoji: "🍇" } }, { label: "Pisang", visual: { type: "emoji", emoji: "🍌" } }, { label: "Jeruk", visual: { type: "emoji", emoji: "🍊" } }, { label: "Apel", visual: { type: "emoji", emoji: "🍎" } }],
      answer: 2, explain: "Jeruk warnanya orange!" },
    { q: "Buah apa yang kecil-kecil ungu?", visual: { type: "emoji", emoji: "🍇", size: "big" },
      options: [{ label: "Stroberi", visual: { type: "emoji", emoji: "🍓" } }, { label: "Ceri", visual: { type: "emoji", emoji: "🍒" } }, { label: "Apel", visual: { type: "emoji", emoji: "🍎" } }, { label: "Anggur", visual: { type: "emoji", emoji: "🍇" } }],
      answer: 3, explain: "Anggur kecil-kecil dan ungu!" },
    { q: "Buah apa yang merah kecil berbiji?", visual: { type: "emoji", emoji: "🍓", size: "big" },
      options: [{ label: "Stroberi", visual: { type: "emoji", emoji: "🍓" } }, { label: "Apel", visual: { type: "emoji", emoji: "🍎" } }, { label: "Semangka", visual: { type: "emoji", emoji: "🍉" } }, { label: "Pisang", visual: { type: "emoji", emoji: "🍌" } }],
      answer: 0, explain: "Stroberi merah kecil dan manis!" },
  ],
  tubuh: [
    { q: "Kita melihat dengan apa?", visual: { type: "emoji", emoji: "👀", size: "big" },
      options: [{ label: "Telinga", visual: { type: "emoji", emoji: "👂" } }, { label: "Mata", visual: { type: "emoji", emoji: "👀" } }, { label: "Hidung", visual: { type: "emoji", emoji: "👃" } }, { label: "Mulut", visual: { type: "emoji", emoji: "👄" } }],
      answer: 1, explain: "Kita melihat dengan mata!" },
    { q: "Kita mendengar dengan apa?", visual: { type: "emoji", emoji: "👂", size: "big" },
      options: [{ label: "Mata", visual: { type: "emoji", emoji: "👀" } }, { label: "Telinga", visual: { type: "emoji", emoji: "👂" } }, { label: "Tangan", visual: { type: "emoji", emoji: "✋" } }, { label: "Kaki", visual: { type: "emoji", emoji: "🦶" } }],
      answer: 1, explain: "Kita mendengar dengan telinga!" },
    { q: "Kita berjalan dengan apa?", visual: { type: "emoji", emoji: "🦶", size: "big" },
      options: [{ label: "Tangan", visual: { type: "emoji", emoji: "✋" } }, { label: "Mata", visual: { type: "emoji", emoji: "👀" } }, { label: "Mulut", visual: { type: "emoji", emoji: "👄" } }, { label: "Kaki", visual: { type: "emoji", emoji: "🦶" } }],
      answer: 3, explain: "Kita berjalan dengan kaki!" },
    { q: "Kita makan dengan apa?", visual: { type: "emoji", emoji: "👄", size: "big" },
      options: [{ label: "Mulut", visual: { type: "emoji", emoji: "👄" } }, { label: "Telinga", visual: { type: "emoji", emoji: "👂" } }, { label: "Mata", visual: { type: "emoji", emoji: "👀" } }, { label: "Hidung", visual: { type: "emoji", emoji: "👃" } }],
      answer: 0, explain: "Kita makan dengan mulut!" },
    { q: "Kita mencium bau dengan apa?", visual: { type: "emoji", emoji: "👃", size: "big" },
      options: [{ label: "Mata", visual: { type: "emoji", emoji: "👀" } }, { label: "Telinga", visual: { type: "emoji", emoji: "👂" } }, { label: "Hidung", visual: { type: "emoji", emoji: "👃" } }, { label: "Tangan", visual: { type: "emoji", emoji: "✋" } }],
      answer: 2, explain: "Kita mencium bau dengan hidung!" },
    { q: "Kita menulis dengan apa?", visual: { type: "emoji", emoji: "✋", size: "big" },
      options: [{ label: "Kaki", visual: { type: "emoji", emoji: "🦶" } }, { label: "Tangan", visual: { type: "emoji", emoji: "✋" } }, { label: "Mulut", visual: { type: "emoji", emoji: "👄" } }, { label: "Telinga", visual: { type: "emoji", emoji: "👂" } }],
      answer: 1, explain: "Kita menulis dengan tangan!" },
  ],
};

// Get random question from any category
export const getRandomQuestion = () => {
  const categories = Object.keys(QUESTIONS);
  const cat = categories[Math.floor(Math.random() * categories.length)];
  const pool = QUESTIONS[cat];
  const q = pool[Math.floor(Math.random() * pool.length)];
  return { ...q, category: cat };
};

// Player colors, characters, and icons
export const PLAYER_CONFIGS = [
  { color: "#FFD700", name: "Pemain 1", emoji: "\uD83D\uDFE1", character: "lion", charEmoji: "\uD83E\uDD81", charName: "Singa" },
  { color: "#FF6B6B", name: "Pemain 2", emoji: "\uD83D\uDD34", character: "cat", charEmoji: "\uD83D\uDC31", charName: "Kucing" },
  { color: "#4ECDC4", name: "Pemain 3", emoji: "\uD83D\uDFE2", character: "rabbit", charEmoji: "\uD83D\uDC30", charName: "Kelinci" },
  { color: "#A855F7", name: "Pemain 4", emoji: "\uD83D\uDFE3", character: "owl", charEmoji: "\uD83E\uDD89", charName: "Burung Hantu" },
];

// Get center position of a square for SVG overlay (in percentage)
export const getSquareCenter = (num) => {
  const pos = squareToPosition(num);
  return {
    x: (pos.col + 0.5) * 10,
    y: (pos.row + 0.5) * 10,
  };
};

// Square colors for the board - matching reference image pattern
export const getSquareColor = (num) => {
  // Board colors matching reference: white, pink, orange, purple, light blue
  const BOARD_COLORS = [
    { bg: "rgba(255,255,255,0.95)", border: "rgba(200,200,200,0.5)" },    // white
    { bg: "rgba(255,182,193,0.9)", border: "rgba(233,30,99,0.3)" },       // pink
    { bg: "rgba(255,200,120,0.9)", border: "rgba(255,152,0,0.4)" },       // orange
    { bg: "rgba(200,180,255,0.9)", border: "rgba(130,80,220,0.4)" },      // purple
    { bg: "rgba(173,216,230,0.9)", border: "rgba(100,149,237,0.4)" },     // light blue
  ];
  if (num === 100) return { bg: "rgba(255,215,0,0.95)", border: "rgba(255,165,0,0.8)" };
  if (num === 1) return { bg: "rgba(144,238,144,0.95)", border: "rgba(76,175,80,0.7)" };
  if (QUESTION_SQUARES.includes(num)) return { bg: "rgba(255,255,150,0.9)", border: "rgba(255,215,0,0.6)" };
  const pos = squareToPosition(num);
  const colorIdx = (pos.row + pos.col) % BOARD_COLORS.length;
  return BOARD_COLORS[colorIdx];
};

// Sound effects & TTS
export const speakText = (text, rate = 0.85) => {
  try {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = getVoiceLang();
    u.rate = rate;
    u.pitch = 1.0;
    u.volume = 1.0;
    const voices = window.speechSynthesis.getVoices();
    const idVoice = voices.find(v => v.lang.startsWith('id'));
    if (idVoice) u.voice = idVoice;
    window.speechSynthesis.speak(u);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playStepSound = (stepNum) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.value = 400 + stepNum * 60;
    osc.type = "sine";
    gain.gain.setValueAtTime(0.08, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.1);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.1);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playDiceSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.value = 200;
    osc.type = "square";
    gain.gain.setValueAtTime(0.1, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.15);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playCorrectSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784].forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = f;
      osc.type = "sine";
      gain.gain.setValueAtTime(0.15, ctx.currentTime + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.12 + 0.3);
      osc.start(ctx.currentTime + i * 0.12);
      osc.stop(ctx.currentTime + i * 0.12 + 0.3);
    });
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playWrongSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.value = 150;
    osc.type = "sawtooth";
    gain.gain.setValueAtTime(0.1, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.4);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playClimbSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [300, 400, 500, 600].forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = f;
      osc.type = "sine";
      gain.gain.setValueAtTime(0.08, ctx.currentTime + i * 0.1);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.1 + 0.15);
      osc.start(ctx.currentTime + i * 0.1);
      osc.stop(ctx.currentTime + i * 0.1 + 0.15);
    });
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playSlideSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(600, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(100, ctx.currentTime + 0.5);
    osc.type = "sine";
    gain.gain.setValueAtTime(0.1, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.5);
  } catch (err) { logger.debug("audio op failed", err); }
};
